
export default {
	buddyList: state => state.buddyList.map(id => state.buddies[id]),
}